import React from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import MarkerGreen from '../../../assets/images/MarkerGreen.png';

export const markerIcon = new L.Icon({
  iconUrl: MarkerGreen,
  popupAnchor: [-2, -17],
  iconAnchor: [20, 35],
  iconSize: [35, 35],
});

const GreenMarkerIcon = (props): JSX.Element => {
  const { position, popupText } = props;
  return (
    <Marker position={position} icon={markerIcon}>
      {popupText && <Popup>{popupText}</Popup>}
    </Marker>
  );
};

GreenMarkerIcon.propTypes = {
  position: PropTypes.arrayOf(PropTypes.any).isRequired,
  popupText: PropTypes.string,
};

GreenMarkerIcon.defaultProps = {
  popupText: '',
};

export default GreenMarkerIcon;
